import {
  DateRangePickerProps,
  DateValue,
  DateRangePicker as NextDateRangePicker,
} from "@nextui-org/react";
import CustomDropdown from "../admin/customdropdown";
import { useEffect, useState } from "react";
import {
  fromDate,
  getLocalTimeZone,
  now,
  today,
} from "@internationalized/date";
import { getPresetDate } from "@/utils/common";

const datePresets = [
  { label: "Today", value: "day" },
  { label: "This Week", value: "week" },
  { label: "This Month", value: "month" },
  { label: "This Year", value: "year" },
];

export const DateRangePicker = (props: DateRangePickerProps) => {
  const [startDate, setStartDate] = useState(
    props?.defaultValue?.start ?? now(getLocalTimeZone()),
  );
  const [endDate, setEndDate] = useState(
    props?.defaultValue?.end ?? now(getLocalTimeZone()),
  );

  useEffect(() => {
    props?.onChange &&
      props.onChange({
        start: startDate,
        end: endDate,
      } as any);
  }, [startDate, endDate]);

  return (
    <div className="flex flex-row gap-4">
      <NextDateRangePicker
        className="dark"
        classNames={{
          inputWrapper: "input-bg",
        }}
        value={{
          start: startDate as any,
          end: endDate as any,
        }}
        onChange={(e: any) => {
          setStartDate(e.start);
          setEndDate(e.end);
          props?.onChange && props.onChange(e);
        }}
      />
      <CustomDropdown
        className="w-48"
        options={datePresets}
        placeholder={datePresets[0].label}
        onSelect={(e: any) => {
          const { startDate: start, endDate: end } = getPresetDate(e.value);
          const startDate = fromDate(start, getLocalTimeZone());
          const endDate = fromDate(end, getLocalTimeZone());
          console.log(startDate);
          setStartDate(startDate);
          setEndDate(endDate);
        }}
      />
    </div>
  );
};
